import {
  ApolloClient,
  HttpLink,
  ApolloLink,
  InMemoryCache,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { BASEURL } from "components/Utils/Constants";

const removeItemFromStorage = (item) =>
  window.localStorage.removeItem.bind(item);

// Set up Cache
const cache = new InMemoryCache();

const authLink = setContext((_, { headers }) => {
  const token = localStorage.token;

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : null,
    },
  };
});

const httpLink = new HttpLink({
  uri: `${BASEURL}/graphql`,
  credentials: "same-origin",
});

const authErrorHandler = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message }) => {
      if (message === "Unauthenticated") {
        removeItemFromStorage("currentUser");
        if (window && window.location) {
          window.location.reload();
        }
      }
      return null;
    });
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([authLink, authErrorHandler, httpLink]),
  cache,
  connectToDevTools: process.env.NODE_ENV === "development",
});

export default client;
